import Comparison1 from '@elem/compPage/delta-3-max-series/pages/product/components/Comparison_back';
import CutCosts from '@elem/compPage/delta-3-max-series/pages/product/components/CutCosts';
import PhoneSection from '@elem/compPage/delta-3-max-series/pages/product/components/PhoneSection';
import TabSection from '@elem/compPage/delta-3-max-series/pages/product/components/TabSection';
import TC from '@elem/compPage/delta-3-max-series/pages/product/components/TC';
import Automotive from '@elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/Automotive';
import Automotive2 from '@elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/Automotive2/index.';
import Banner from '@elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/Banner';
import Built from '@elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/Built';
import ChargeUp from '@elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/ChargeUp';
import Essentials from '@elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/Essentials';
import PriorityOutputs from '@elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/PriorityOutputs';
import BottomAction from '@elem/compPage/delta-3-ultra-portable-power-station/pages/product/components/BottomAction';
import ImgSection from '@elem/compPage/delta-3-max-series/pages/product/components/Common/ImgSection';
import { useState } from 'react';
import ProductNav from '../../../../common/ProductNavUs';
import OnePicture from '../../components/OnePicture';
import ProductList from '../../components/ProductList';
import styles from './index.module.scss';
import './nav.scss';

import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import * as config from './config';
import Output from '../../components/Output';
import PageNavLeft from '@elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/PageNavLeft';

const StatusA: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('StatusA');
    const { t: tPageNavLeft } = useLang('PageNavLeft');

    const [activeTab, setActiveTab] = useState('Product');
    const img1Config = config.getCoverSectionConfig('img1', locale);
    const img2Config = config.getCoverSectionConfig('img2', locale);
    const img3Config = config.getCoverSectionConfig('img3', locale);
    const img4Config = config.getCoverSectionConfig('img4', locale);

    const tcConfig = config.getTcConfig();

    return (
        <div className={styles.StatusA} id="StatusA">
            <ProductNav activeTab={activeTab} tabCallback={setActiveTab} />

            {(activeTab === 'Product' || activeTab === 'Compare') && (
                <>
                    <BottomAction pageType="max" />
                    <Banner pageType="max" />

                    <div className="range1">
                        <OnePicture />
                    </div>
                    <ProductList />
                    <ImgSection key="img1" {...img1Config} />
                    {/* <MorePower /> */}

                    <div className="range2">
                        <Output />
                    </div>
                    <Essentials pageType="max" />
                    <PriorityOutputs pageType="max" />
                    <ImgSection key="img2" {...img2Config} />
                    <div className="range3">
                        <Automotive />
                        <Automotive2 />
                    </div>

                    <Built pageType="max" />
                    <ImgSection key="img3" {...img3Config} />

                    <div className="range4">
                        <ChargeUp pageType="max" />
                    </div>
                    <div className="range5">
                        <PhoneSection />
                    </div>

                    <CutCosts />

                    <ImgSection key="img4" {...img4Config} />

                    <div className="range6">
                        <TabSection />
                    </div>
                    <div style={{ background: '#fff' }}>
                        <Comparison1 />
                    </div>
                    <TC key="TC" {...{ config: { ...tcConfig } }} />

                    {/* 左侧锚点 */}
                    <PageNavLeft
                        triggerElement={`#StatusA`}
                        enterElement="#OnePicture"
                        triggerElements={[{ selectors: `#StatusA`, theme: 'white' }]}
                        isUs={false}
                        steps={[
                            { text: tPageNavLeft('item1'), href: '#OnePicture', rangeClass: 'range1' },
                            { text: tPageNavLeft('item2'), href: '#Output', rangeClass: 'range2' },
                            { text: tPageNavLeft('item3'), href: '#d3m-automotive', rangeClass: 'range3' },
                            { text: tPageNavLeft('item4'), href: '#ChargeUp', rangeClass: 'range4' },
                            { text: tPageNavLeft('item5'), href: '#phoneSection', rangeClass: 'range5' },
                            { text: tPageNavLeft('item6'), href: '#TabSection', rangeClass: 'range6' },
                        ]}
                    />
                </>
            )}

            {/* {activeTab === 'Specs' && (
                <>
                    <Specs />
                </>
            )}
            {activeTab === 'Support' && (
                <>
                    <Support />
                </>
            )} */}
        </div>
    );
};

export default StatusA;
